import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        margin: 10
    },
    title: {
        paddingTop: 20,
        paddingBottom: 10
    },
    gridLitrage: {
        marginTop: 15,
        marginBottom: 15
    },
    icon: {
        textAlign: 'left'
    }
}))
